import { connect } from "react-redux";
import {
  acknowledgeCareWatchSignalsRequest,
  setCareWatchRiskRequest,
  clearCareWatchFilters,
  getCareWatchDetailRequest,
  getCareWatchListRequest,
  getCareWatchOverviewRequest,
  promoteCareWatchSignalRequest,
  resetCareWatch,
  setCareWatchFilter,
  setCareWatchFilters,
  setCareWatchPage,
  setCareWatchPageSize,
  setCareWatchSelected,
  toggleCareWatchChecked,
  toggleCareWatchRow,
  resetCareWatchUpdatedPusher,
} from "store/actions/careWatch.actions";
import {
  getCareWatchAcknowledgeLoading,
  getCareWatchDetailLoading,
  getCareWatchFiltered,
  getCareWatchFilters,
  getCareWatchHasActiveFilters,
  getCareWatchKpis,
  getCareWatchListLoading,
  getCareWatchMatchCaption,
  getCareWatchOverview,
  getCareWatchPageSize,
  getCareWatchPromoteHighlight,
  getCareWatchPromoteLoading,
  getCareWatchRiskSavingId,
  getCareWatchQueueView,
  getCareWatchSelected,
  getCareWatchSignalDates,
  getCareWatchUpdatedByPusher,
} from "store/selector/careWatch.selector";
import CareWatchPage from "./CareWatchPage";
import "./careWatch.css";

const mapStateToProps = (state) => {
  const queue = getCareWatchQueueView(state);
  return {
    filters: getCareWatchFilters(state),
    signalDates: getCareWatchSignalDates(state),
    kpis: getCareWatchKpis(state),
    overview: getCareWatchOverview(state),
    hasActiveFilters: getCareWatchHasActiveFilters(state),
    matchCaption: getCareWatchMatchCaption(state),
    pageItems: queue.pageItems,
    filtered: getCareWatchFiltered(state),
    total: queue.total,
    page: queue.page,
    pageSize: queue.pageSize || getCareWatchPageSize(state),
    totalPages: queue.totalPages,
    selected: getCareWatchSelected(state),
    promoteHighlight: getCareWatchPromoteHighlight(state),
    listLoading: getCareWatchListLoading(state),
    detailLoading: getCareWatchDetailLoading(state),
    acknowledgeLoading: getCareWatchAcknowledgeLoading(state),
    promoteLoading: getCareWatchPromoteLoading(state),
    riskSavingId: getCareWatchRiskSavingId(state),
    careWatchUpdatedPusher: getCareWatchUpdatedByPusher(state),
  };
};

const mapDispatchToProps = {
  loadQueue: getCareWatchListRequest,
  loadDetail: getCareWatchDetailRequest,
  loadOverview: getCareWatchOverviewRequest,
  updateFilter: setCareWatchFilter,
  updateFilters: setCareWatchFilters,
  clearFilters: clearCareWatchFilters,
  setPage: setCareWatchPage,
  setPageSize: setCareWatchPageSize,
  toggleRow: toggleCareWatchRow,
  setSelectedId: setCareWatchSelected,
  toggleChecked: toggleCareWatchChecked,
  acknowledgeIds: (ids) => acknowledgeCareWatchSignalsRequest({ ids }),
  promoteItem: (id) => promoteCareWatchSignalRequest({ id }),
  changeRisk: setCareWatchRiskRequest,
  resetCareWatch,
  resetCareWatchUpdatedPusher,
};

export default connect(mapStateToProps, mapDispatchToProps)(CareWatchPage);
